import { useParams } from 'react-router-dom';

import type { AssetType } from '../asset-type';
import { isAssetType } from '../asset-type';

export const useAssetTypeParam = (defaultAssetType: AssetType = 'devices') => {
  const { assetType: assetTypeParam } = useParams();

  if (isAssetType(assetTypeParam)) {
    return assetTypeParam;
  }

  return defaultAssetType;
};
